import dayjs from "dayjs";

export const getCurrentDateRange = (
  type = "week",
  value,
  dateFormat = "YYYY-MM-DD"
) => {
  switch (type) {
    case "day":
      return [
        dayjs().format(dateFormat),
        dayjs().format(dateFormat),
      ];
    case "week":
      return [
        dayjs(value).startOf("week").format(dateFormat),
        dayjs(value).endOf("week").format(dateFormat),
      ];
    case "month":
      return [
        dayjs(value).startOf("month").format(dateFormat),
        dayjs(value).endOf("month").format(dateFormat),
      ];
  }
};

export const customWeekStartEndFormat = (value, weekFormat = "DD/MM/YY") => {
  return `${dayjs(value).startOf("week").format(weekFormat)} - ${dayjs(value)
    .endOf("week")
    .format(weekFormat)}`;
};
